"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = exports.ContentBoxEmpty = void 0;
const react_1 = __importDefault(require("react"));
const Empty = (props) => (react_1.default.createElement("div", { className: "gap-2 bg-misc-50 border-misc-200 rounded-md flex flex-col p-6 text-center font-medium text-secondary-500" },
    react_1.default.createElement("p", { className: "text-sm" }, props.children),
    props.option && react_1.default.createElement("div", { className: "mt-1" }, props.option)));
exports.Empty = Empty;
const ContentBoxEmpty = ({ children, option, className = 'p-4 sm:p-6', }) => (react_1.default.createElement("div", { className: className },
    react_1.default.createElement(Empty, { option: option }, children)));
exports.ContentBoxEmpty = ContentBoxEmpty;
//# sourceMappingURL=ContentBoxEmpty.js.map